import React, { Component } from "react";
import "./style.css";
import NewsTemplate from "./newsTemplate";

class News extends Component {
  render() {
    return (
      <section id="home-news">
        <div className="row">
          <div className="col pl-0 home-news-wrapper">
            <div className="home-news-content  text-center">
              <span>
                <img
                  className="img-fluid"
                  src={require("../../../assets/icons/eco-system.png")}
                  alt=""
                />{" "}
                Ecosystem
              </span>
              <h1
                className="text-center mt-2"
                style={{
                  color: "var(--h1Color)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                News & Dev Updates
              </h1>

              <div className="inner-new-row">
                <div className="row mt-10 m-0 text-center news-and-dev-carousel">
                  <NewsTemplate />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default News;
